import Layout from '@/layout'

const ApprovalMattersRouter = {
  path: '/ApprovalMatters',
  component: Layout,
  redirect: 'noredirect',
  name: 'ApprovalMatters',
  meta: {
    title: '审批事项',
    icon: 'approvalMatters',
    roles: []
  },
  children: [
    {
      path: 'ApprovalChecklist',
      component: () => import('@/views/cargo/v0/ApprovalMatters/ApprovalChecklist/index'),
      name: '审批事项清单',
      meta: { title: 'ApprovalChecklist' },
      roles: ['module_ApprovalChecklistModule']
    },
    {
      path: 'EnterpriseWechatApprovalChecklist',
      component: () => import('@/views/cargo/v0/ApprovalMatters/EnterpriseWechatApprovalChecklist/index'),
      name: 'EnterpriseWechatApprovalChecklist',
      meta: { title: 'EnterpriseWechatApprovalChecklist' },
      roles: ['module_EnterpriseWechatApprovalChecklistModule']
    }
  ]
}

export default ApprovalMattersRouter
